import 'bootstrap/dist/css/bootstrap.min.css';
import { createRoot } from 'react-dom/client';
import AppProvider from './AppProvider';
import './assets/scss/global.scss';
import { APP_ENV } from './constants/constants';
import * as Sentry from "@sentry/react";

window.dataLayer = window.dataLayer || [];
window.gmo = window.gmo || {};

window.dataLayer.push({
    environnement: APP_ENV,
});

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.1,
    tracesSampleRate: 0.01,
    environment: APP_ENV,
    enabled: true
});

const root = createRoot(document.getElementById('root'));

if (APP_ENV) {
    root.render(<AppProvider />);
} else {
    root.render(<h1>.env requis à la racine du projet, un npm start est nécessaire.</h1>);
}
